const autoNgTemplateLoaderTemplate1 = require('./helm-templates-list-item.html');

import angular from 'angular';
import './helm-templates-list-item.css';

angular.module('shbdeployer.kubernetes').component('helmTemplatesListItem', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '<',
    onSelect: '<',
  },
  transclude: {
    actions: '?templateItemActions',
  },
});
